import { html, TemplateResult, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import globalStyles from './outline-grid.global.pcss?inline';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';

type Size =
  | '3xs'
  | '2xs'
  | 'xs'
  | 's'
  | 'm'
  | 'l'
  | 'xl'
  | '2xl'
  | '3xl'
  | '4xl'
  | 'none';

/**
 * The Outline Grid component
 * @element outline-grid
 *
 * Creates a 12 column grid for use with outline-column.
 * Supports use of the web component or simple utility classes.
 *
 * @slot The default slot for this element.
 * @attr {string} gap-size - the width of the spacing between each column.
 *
 * @todo udpate to follow tufts model. (note, outline_layouts module and others require updates to change this.)
 */
@customElement('outline-grid')
export class OutlineGrid extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
  });

  /**
   * How much of a gap should exist between columns? (This affects both the vertical and horizontal column/row gaps.)
   */
  @property({ type: String, reflect: true, attribute: 'gap-size' })
  gapSize: Size = 'none';

  render(): TemplateResult {
    return html` <slot></slot> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'outline-grid': OutlineGrid;
  }
}
